import styled from 'styled-components';

export const FeedbackOptionWrapper = styled.div`
  font-size: 2.5rem;
  cursor: pointer;
  color: var(--gray-light);
  &:hover {
    color: var(--brand-primary);
  }
  &.active {
    color: var(--brand-primary);
  }
`;
